const assignGlobalSingleton = (name, value) => {
  const __YAGE__ = window.__YAGE__ ?? {};
  if (!__YAGE__[name]) {
    __YAGE__[name] = value();
  }
  window.__YAGE__ = __YAGE__;
  return __YAGE__[name];
};
const setGlobalSingleton = (name, value) => {
  const __YAGE__ = window.__YAGE__ ?? {};
  __YAGE__[name] = value;
  window.__YAGE__ = __YAGE__;
  return __YAGE__[name];
};
const getGlobalSingleton = (name) => {
  return window.__YAGE__[name];
};
export {
  assignGlobalSingleton as a,
  getGlobalSingleton as g,
  setGlobalSingleton as s
};
//# sourceMappingURL=global-33d5eebf.js.map
